export const SAVE_LOGO_REQUEST = 'SAVE_LOGO_REQUEST';
export const SAVE_LOGO_FAILURE = 'SAVE_LOGO_FAILURE';
export const SAVE_LOGO_SUCCESS = 'SAVE_LOGO_SUCCESS';
export const SET_LOGO_PREVIEW = 'SET_LOGO_PREVIEW';
